import {
  EventIncidentsQueue,
  QueueIncident,
  QueueStatus,
  type RawQueueIncident,
} from '@collector/desktop-feature-incidents-queue-core'
import { Event } from '@collector/sportsapi-client-legacy'
import {
  EventIncidentsQueueRecord,
  EventIncidentsQueueTable,
} from '@desktop/utils/database'

function toRawQueueIncidents(
  queueIncidents: QueueIncident[],
): RawQueueIncident[] {
  // Class instances are not structured-cloneable for IndexedDB.
  return JSON.parse(JSON.stringify(queueIncidents)) as RawQueueIncident[]
}

function persistEventIncidentsQueue(
  eventId: Event['id'],
  queueIncidents: QueueIncident[],
  queueStatus: QueueStatus,
): void {
  EventIncidentsQueueTable.put(eventId, {
    eventId,
    rawQueueIncidents: toRawQueueIncidents(queueIncidents),
    queueStatus,
  })
}

/**
 * save queue on every change to persistent storage
 */
export function persistOnChangeEventIncidentsQueue(
  eventIncidentsQueue: EventIncidentsQueue,
): void {
  eventIncidentsQueue.subscribeOnChange(({ queue, status }) => {
    persistEventIncidentsQueue(eventIncidentsQueue.eventId, queue, status)
  })
}

/**
 * Retrieve queue backup from persistent storage
 */
export async function getEventIncidentsQueueRecord(
  eventId: Event['id'],
): Promise<EventIncidentsQueueRecord | undefined> {
  return EventIncidentsQueueTable.get(eventId)
}
